/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeIReadOnlyListSellbotHologramDto,
  ApiEnvelopeSellbotEmptyDto,
  ApiEnvelopeSellbotHologramBindingsDto,
  ApiEnvelopeSellbotHologramDto,
  ApiEnvelopeSellbotHologramExclusionsDto,
  ApiEnvelopeSellbotHologramLiveDto,
  ApiEnvelopeSellbotHologramRenderDto,
  SellbotHologramExcludedPlayerRequest,
  SellbotHologramRenderRequest,
  SellbotHologramRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type sellbotHologramListResponse200 = {
  data: ApiEnvelopeIReadOnlyListSellbotHologramDto
  status: 200
}

export type sellbotHologramListResponseSuccess = (sellbotHologramListResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramListResponse = (sellbotHologramListResponseSuccess)

export const getSellbotHologramListUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms`
}

export const useSellbotHologramListHook = (): (botId: string, options?: RequestInit) => Promise<sellbotHologramListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramListUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotHologramCreateResponse200 = {
  data: ApiEnvelopeSellbotHologramDto
  status: 200
}

export type sellbotHologramCreateResponseSuccess = (sellbotHologramCreateResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramCreateResponse = (sellbotHologramCreateResponseSuccess)

export const getSellbotHologramCreateUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms`
}

export const useSellbotHologramCreateHook = (): (botId: string,
    sellbotHologramRequest?: SellbotHologramRequest, options?: RequestInit) => Promise<sellbotHologramCreateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotHologramRequest?: SellbotHologramRequest, options?: RequestInit) => {

        return customFetcher(getSellbotHologramCreateUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotHologramRequest)
  }
);
      }
  }


export type sellbotHologramLiveResponse200 = {
  data: ApiEnvelopeSellbotHologramLiveDto
  status: 200
}

export type sellbotHologramLiveResponseSuccess = (sellbotHologramLiveResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramLiveResponse = (sellbotHologramLiveResponseSuccess)

export const getSellbotHologramLiveUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/live`
}

export const useSellbotHologramLiveHook = (): (botId: string, options?: RequestInit) => Promise<sellbotHologramLiveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramLiveUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotHologramRefreshLiveResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotHologramRefreshLiveResponseSuccess = (sellbotHologramRefreshLiveResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramRefreshLiveResponse = (sellbotHologramRefreshLiveResponseSuccess)

export const getSellbotHologramRefreshLiveUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/live/refresh`
}

export const useSellbotHologramRefreshLiveHook = (): (botId: string, options?: RequestInit) => Promise<sellbotHologramRefreshLiveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramRefreshLiveUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotHologramBindingsResponse200 = {
  data: ApiEnvelopeSellbotHologramBindingsDto
  status: 200
}

export type sellbotHologramBindingsResponseSuccess = (sellbotHologramBindingsResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramBindingsResponse = (sellbotHologramBindingsResponseSuccess)

export const getSellbotHologramBindingsUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/bindings`
}

export const useSellbotHologramBindingsHook = (): (botId: string, options?: RequestInit) => Promise<sellbotHologramBindingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramBindingsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotHologramUpdateResponse200 = {
  data: ApiEnvelopeSellbotHologramDto
  status: 200
}

export type sellbotHologramUpdateResponseSuccess = (sellbotHologramUpdateResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramUpdateResponse = (sellbotHologramUpdateResponseSuccess)

export const getSellbotHologramUpdateUrl = (botId: string,
    hologramId: string,) => {




  return `/api/sellbot/${botId}/holograms/${hologramId}`
}

export const useSellbotHologramUpdateHook = (): (botId: string,
    hologramId: string,
    sellbotHologramRequest?: SellbotHologramRequest, options?: RequestInit) => Promise<sellbotHologramUpdateResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    hologramId: string,
    sellbotHologramRequest?: SellbotHologramRequest, options?: RequestInit) => {

        return customFetcher(getSellbotHologramUpdateUrl(botId,hologramId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotHologramRequest)
  }
);
      }
  }


export type sellbotHologramDeleteResponse200 = {
  data: ApiEnvelopeSellbotEmptyDto
  status: 200
}

export type sellbotHologramDeleteResponseSuccess = (sellbotHologramDeleteResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramDeleteResponse = (sellbotHologramDeleteResponseSuccess)

export const getSellbotHologramDeleteUrl = (botId: string,
    hologramId: string,) => {




  return `/api/sellbot/${botId}/holograms/${hologramId}`
}

export const useSellbotHologramDeleteHook = (): (botId: string,
    hologramId: string, options?: RequestInit) => Promise<sellbotHologramDeleteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    hologramId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramDeleteUrl(botId,hologramId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotHologramExclusionsResponse200 = {
  data: ApiEnvelopeSellbotHologramExclusionsDto
  status: 200
}

export type sellbotHologramExclusionsResponseSuccess = (sellbotHologramExclusionsResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramExclusionsResponse = (sellbotHologramExclusionsResponseSuccess)

export const getSellbotHologramExclusionsUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/exclusions`
}

export const useSellbotHologramExclusionsHook = (): (botId: string, options?: RequestInit) => Promise<sellbotHologramExclusionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramExclusionsUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type sellbotHologramAddExcludedPlayerResponse200 = {
  data: ApiEnvelopeSellbotHologramExclusionsDto
  status: 200
}

export type sellbotHologramAddExcludedPlayerResponseSuccess = (sellbotHologramAddExcludedPlayerResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramAddExcludedPlayerResponse = (sellbotHologramAddExcludedPlayerResponseSuccess)

export const getSellbotHologramAddExcludedPlayerUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/exclusions/players`
}

export const useSellbotHologramAddExcludedPlayerHook = (): (botId: string,
    sellbotHologramExcludedPlayerRequest?: SellbotHologramExcludedPlayerRequest, options?: RequestInit) => Promise<sellbotHologramAddExcludedPlayerResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotHologramExcludedPlayerRequest?: SellbotHologramExcludedPlayerRequest, options?: RequestInit) => {

        return customFetcher(getSellbotHologramAddExcludedPlayerUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotHologramExcludedPlayerRequest)
  }
);
      }
  }


export type sellbotHologramRemoveExcludedPlayerResponse200 = {
  data: ApiEnvelopeSellbotHologramExclusionsDto
  status: 200
}

export type sellbotHologramRemoveExcludedPlayerResponseSuccess = (sellbotHologramRemoveExcludedPlayerResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramRemoveExcludedPlayerResponse = (sellbotHologramRemoveExcludedPlayerResponseSuccess)

export const getSellbotHologramRemoveExcludedPlayerUrl = (botId: string,
    exclusionId: string,) => {




  return `/api/sellbot/${botId}/holograms/exclusions/players/${exclusionId}`
}

export const useSellbotHologramRemoveExcludedPlayerHook = (): (botId: string,
    exclusionId: string, options?: RequestInit) => Promise<sellbotHologramRemoveExcludedPlayerResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    exclusionId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramRemoveExcludedPlayerUrl(botId,exclusionId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotHologramAttachExcludedListResponse200 = {
  data: ApiEnvelopeSellbotHologramExclusionsDto
  status: 200
}

export type sellbotHologramAttachExcludedListResponseSuccess = (sellbotHologramAttachExcludedListResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramAttachExcludedListResponse = (sellbotHologramAttachExcludedListResponseSuccess)

export const getSellbotHologramAttachExcludedListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/sellbot/${botId}/holograms/exclusions/lists/${playerListId}`
}

export const useSellbotHologramAttachExcludedListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<sellbotHologramAttachExcludedListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramAttachExcludedListUrl(botId,playerListId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type sellbotHologramDetachExcludedListResponse200 = {
  data: ApiEnvelopeSellbotHologramExclusionsDto
  status: 200
}

export type sellbotHologramDetachExcludedListResponseSuccess = (sellbotHologramDetachExcludedListResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramDetachExcludedListResponse = (sellbotHologramDetachExcludedListResponseSuccess)

export const getSellbotHologramDetachExcludedListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/sellbot/${botId}/holograms/exclusions/lists/${playerListId}`
}

export const useSellbotHologramDetachExcludedListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<sellbotHologramDetachExcludedListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getSellbotHologramDetachExcludedListUrl(botId,playerListId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type sellbotHologramRenderResponse200 = {
  data: ApiEnvelopeSellbotHologramRenderDto
  status: 200
}

export type sellbotHologramRenderResponseSuccess = (sellbotHologramRenderResponse200) & {
  headers: Headers;
};
;

export type sellbotHologramRenderResponse = (sellbotHologramRenderResponseSuccess)

export const getSellbotHologramRenderUrl = (botId: string,) => {




  return `/api/sellbot/${botId}/holograms/render`
}

export const useSellbotHologramRenderHook = (): (botId: string,
    sellbotHologramRenderRequest?: SellbotHologramRenderRequest, options?: RequestInit) => Promise<sellbotHologramRenderResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    sellbotHologramRenderRequest?: SellbotHologramRenderRequest, options?: RequestInit) => {

        return customFetcher(getSellbotHologramRenderUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(sellbotHologramRenderRequest)
  }
);
      }
  }


